import { Scroll } from 'components/scroll'
import inView from 'in-view'

function removeSelectedButtom(elements) {
    Array.prototype.forEach.call(elements, btn => {
        let paymentIcon = btn.firstElementChild
        if (paymentIcon != null && paymentIcon != 'undefined') paymentIcon.classList.remove('svg--actived')
        let rightIcon = btn.lastElementChild
        if (rightIcon != null && rightIcon != 'undefined') rightIcon.classList.remove('svg--actived')
        btn.classList.remove('btn--selected')
        if(btn.querySelector('.dot-bc')) btn.querySelector('.dot-bc').style.display = "block"
        if(btn.querySelector('.checked-bc')) btn.querySelector('.checked-bc').style.display = "none"
    })
}

function addSelectedButtom(target) {
    let paymentIcon = target.firstElementChild
    if (paymentIcon != null && paymentIcon != 'undefined') paymentIcon.classList.add('svg--actived')
    let rightIcon = target.lastElementChild
    if (rightIcon != null && rightIcon != 'undefined') rightIcon.classList.add('svg--actived')
    target.classList.add('btn--selected');
    if(target.querySelector('.dot-bc'))
    target.querySelector('.dot-bc').style.display = "none"

    if(target.querySelector('.checked-bc'))
    target.querySelector('.checked-bc').style.display = "block"
}

function checkContentHeight() {
    const checkout = document.querySelector(".checkout");
    if(checkout) {
        const stepActivedElement = document.querySelector(`.${checkout.getAttribute("data-step")}`);
        checkout.style.height = `${(stepActivedElement) ? stepActivedElement.clientHeight + 60 : document.querySelector(".checkout-resumo").clientHeight + 60}px`;
    }

}

function clearEntregaContainer() {
    const alertElement = document.querySelector('.checkout-entrega__enderecos.checkout__step-alert');
    const enderecosContainer = document.querySelector(".checkout-entrega__enderecos");

    if(alertElement) alertElement.classList.remove('checkout__step-alert');
    enderecosContainer.innerHTML = '';

}

function clearPagamentoContainer() {
    const alertElement = document.querySelector('.checkout-pagamento__info.checkout__step-alert');
    const pagamentoContainer = document.querySelector(".checkout-pagamento__info");

    if(alertElement) alertElement.classList.remove('checkout__step-alert');
    pagamentoContainer.innerHTML = '';

}

function addStepAlert() {
    console.log('aaaa')
    const enderecosContainer = document.querySelector(".checkout-entrega__enderecos");
    enderecosContainer.classList.add('checkout__step-alert');
}

function scrolToElement(element) {
    if(element) {
        inView.threshold(0.5);
        if(!inView.is(element)) new Scroll(element, 300);
    }
}

export { removeSelectedButtom, addSelectedButtom, checkContentHeight, clearEntregaContainer, scrolToElement, clearPagamentoContainer, addStepAlert };



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/checkout/checkout.utils.js